document.addEventListener("DOMContentLoaded", function() {
    let scrollPosition = parseInt(localStorage.getItem("scrollPosition")) || 0;
    let clickCount = parseInt(localStorage.getItem("clickCount")) || 0;
    console.log('scrollPosition load', scrollPosition);

    let loadMoreButton = document.getElementById("load-more-button");
    if (clickCount > 0 && loadMoreButton) {
        for (let i = 0; i < clickCount; i++) {
            loadMoreButton.click();
        }
    }
    document.getElementById("load-more-button")?.addEventListener("click", function() {
        clickCount++;
        localStorage.setItem("clickCount", clickCount);
    });
        window.scrollTo(0, scrollPosition);
        console.log('scrollPosition setTimeout', scrollPosition)
        localStorage.removeItem("scrollPosition");

    
});

document.addEventListener("visibilitychange", function() {
    if (document.visibilityState === 'hidden') {
        console.log('scrollPosition visibilitychange', window.scrollY);
        localStorage.setItem("scrollPosition", window.scrollY);
    }
});

